<div class="upload-container">
    <div class="drop-zone" [class.drag-over]="isDragging" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (click)="fileInput.click()">
        <input #fileInput type="file" (change)="onFileSelected($event)" accept="image/*" hidden />

        <!-- Initial State -->
        <div *ngIf="!uploading && !uploadedImageUrl && !showSuccessIcon" class="drop-content">
            <svg class="upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <polyline points="17 8 12 3 7 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <line x1="12" y1="3" x2="12" y2="15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <p class="drop-title">{{'Drop your image here' | translate}}</p>
            <p class="drop-subtitle">{{'or click to browse' | translate}}</p>
        </div>

        <!-- Uploading -->
        <div *ngIf="uploading" class="uploading-content">
            <div class="progress-container">
                <div class="progress-bar" [style.width.%]="progress"></div>
            </div>
            <p class="progress-text">{{'Uploading...' | translate}} {{ progress | number:'1.0-0' }}%</p>
        </div>

        <!-- Success: Tick Icon First -->
        <div *ngIf="showSuccessIcon" class="success-content">
            <svg class="success-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <polyline points="22 4 12 14.01 9 11.01" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
            <p class="success-text">{{'Upload successful!' | translate}}</p>
        </div>

        <!-- Success: Image Preview (400x400) -->
        <div *ngIf="uploadedImageUrl && !uploading && !showSuccessIcon" class="success-content">
            <div class="image-wrapper">
                <img [src]="uploadedImageUrl" alt="Uploaded" class="preview-image" />
                <button class="delete-btn" (click)="deleteImage($event)" title="Delete image">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                            d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-8 0h10M6 8v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>